import TextField from "../../../../common/components/inputFields/textFields/textField";
import "./campaignQuestions.scss";
import lightOrDarkColor from "@check-light-or-dark/color";
import {
  CampaignBlockModel,
  OptionModel,
  QuestionModel,
  StoryModel,
} from "../../../createCampaign/models/questionModel";
import { QuestionTypes } from "../../../../common/enums/questionTypes";
import { BlockType } from "../../../createCampaign/enums/blockType";
import Transition from "../../../../common/components/transition/transition";
import { Fragment, useEffect, useState } from "react";
import CampaignMultipleChoose from "../campaignMultipleChoose/campaignMultipleChoose";
import CampaignMultipleChoice from "../campaignMultipleChoice/campaignMultipleChoice";
import Ticket from "../../../../common/components/ticket/ticket";
import { ticketLayouts } from "../../../../common/constants/ticketLayouts";
import domtoimage from "dom-to-image-more";
import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import { uniqueId } from "lodash";
import StaticTicket from "../../../../common/components/staticTicket/staticTicket";
import { ThemeModel } from "../../../createCampaign/models/themeModel";
import { MediaType } from "../../../../common/enums/mediaTypes";
import { TicketDetailModel } from "../../../createCampaign/models/ticketDetailModel";
import { CampaignAnswersModel } from "../../models/campaignAnswersModel";
import { CampaignResponseModel } from "../../models/campaignResponseModel";
import { useLoadHandler } from "../../../../common/customHooks/useLoadHandler";
import { CampaignApi } from "../../../../common/services/api/campaignApi";
import { LoadingStatus } from "../../../../common/enums/loadingStatus";
import { Color } from "../../../../common/style/colors";
import ReactLoading from "react-loading";
import ShareLinkPopup from "../shareLinkPopup/shareLinkPopup";
import { FileApi } from "../../../../common/services/api/fileApi";

export default function CampaignQuestions(props: {
  className?: string;
  theme?: ThemeModel;
  initialData?: CampaignBlockModel[];
  ticketData?: TicketDetailModel;
  campaignId?: string;
  onChange?: (e: CampaignAnswersModel[]) => void;
}) {
  const [index, setIndex] = useState(0);
  const [bg, setBg] = useState(props.theme?.desktopBackground);
  const [userResponse, setUserResponse] = useState<CampaignResponseModel>({});
  const [ticketId, setTicketId] = useState<string>();

  const { loadingStatus, callFetchAsync } = useLoadHandler(async () => {
    let result = await CampaignApi().submitCampaign(
      props.campaignId,
      userResponse
    );
    return () => setTicketId(result.id);
  });

  function calculateScore(answers: CampaignResponseModel): number {
    let score = 0;
    let userAnswers: OptionModel[] = [];
    answers.answers?.forEach((e) => {
      switch (e.questionType) {
        case QuestionTypes.MULTIPLE_CHOICE:
          if (e.multipleChoiceAnswer) userAnswers.push(e.multipleChoiceAnswer);
          break;
        case QuestionTypes.MULTIPLE_CHOOSE:
          e.multipleChooseAnswer?.forEach((e2) => userAnswers.push(e2));
          break;
      }
    });
    userAnswers.forEach((e) => {
      score += e.score ?? 0;
    });
    return score;
  }

  function handleSelection(campaignAnswers: CampaignAnswersModel) {
    switch (campaignAnswers.questionType) {
      case QuestionTypes.SHORT_ANSWER:
        if (
          props.ticketData?.fullName?.isShow &&
          campaignAnswers.id == undefined
        ) {
          setUserResponse({
            ...userResponse,
            fullname: campaignAnswers.shortAnswerAnswer,
          });
        } else {
          if (userResponse.answers?.some((e) => e.id == campaignAnswers.id)) {
            let temp = { ...userResponse };
            temp.answers = temp.answers?.map((e) =>
              e.id != campaignAnswers.id
                ? e
                : { ...e, shortAnswerAnswer: campaignAnswers.shortAnswerAnswer }
            );
            setUserResponse(temp);
          } else {
            setUserResponse({
              ...userResponse,
              answers: [...(userResponse.answers ?? []), campaignAnswers],
            });
          }
        }
        break;
      case QuestionTypes.MULTIPLE_CHOICE:
        if (userResponse.answers?.some((e) => e.id == campaignAnswers.id)) {
          let temp = { ...userResponse };
          temp.answers = temp.answers?.map((e) =>
            e.id != campaignAnswers.id
              ? e
              : {
                  ...e,
                  multipleChoiceAnswer: campaignAnswers.multipleChoiceAnswer,
                }
          );
          setUserResponse(temp);
        } else {
          setUserResponse({
            ...userResponse,
            answers: [...(userResponse.answers ?? []), campaignAnswers],
          });
        }
        break;
      case QuestionTypes.MULTIPLE_CHOOSE:
        if (userResponse.answers?.some((e) => e.id == campaignAnswers.id)) {
          let temp = { ...userResponse };
          temp.answers = temp.answers?.map((e) =>
            e.id != campaignAnswers.id
              ? e
              : {
                  ...e,
                  multipleChooseAnswer: campaignAnswers.multipleChooseAnswer,
                }
          );
          setUserResponse(temp);
        } else {
          setUserResponse({
            ...userResponse,
            answers: [...(userResponse.answers ?? []), campaignAnswers],
          });
        }
        break;
    }
  }

  useEffect(() => {
    window.addEventListener(
      "resize",
      function () {
        setBg(
          window.innerWidth < 600
            ? props.theme?.mobileBackground
            : props.theme?.desktopBackground
        );
      },
      true
    );
    (document.getElementById("video") as HTMLVideoElement)?.play();
  }, []);

  return (
    <div
      className="background"
      style={{
        backgroundColor: bg?.type == MediaType.COLOR ? bg.value : undefined,
        backgroundImage:
          bg?.type == MediaType.IMAGE ? `url(${bg?.value})` : undefined,
      }}
    >
      {bg?.type == MediaType.MP4 ? (
        <video
          id="video"
          className="background-video"
          // autoPlay
          loop
          muted
          poster={bg.value}
        >
          <source src={bg.value} type="video/mp4" />
        </video>
      ) : (
        <></>
      )}
      {props.initialData && (
        <div className="campaign-questions-detail-wrapper">
          <Transition index={index} className="campaign-questions-detail">
            {props.initialData
              ?.map((e, i) => (
                <Fragment key={i}>
                  {e.blockType == BlockType.QUESTION ? (
                    <QuestionBlock
                      data={e.questionBlockDetail}
                      onChange={(e2) => handleSelection(e2)}
                      themeData={props.theme}
                    />
                  ) : (
                    <StoryBlock
                      data={e.storyBlockDetail}
                      themeData={props.theme}
                    />
                  )}
                  <div
                    className="question-button"
                    style={{
                      fontFamily: props.theme?.fontFamily,
                      backgroundColor:
                        props.theme?.themeColor?.value ?? "#ffffff",
                      color:
                        lightOrDarkColor(
                          props.theme?.themeColor?.value ?? "#ffffff"
                        ) === "light"
                          ? "black"
                          : "white",
                    }}
                    onClick={() => {
                      if (index + 1 == props.initialData?.length)
                        callFetchAsync();
                      setIndex(index + 1);
                    }}
                  >
                    {"Continue"}
                  </div>
                  {index > 0 && (
                    <div
                      style={{
                        cursor: "pointer",
                        color: props.theme?.fontColor?.value,
                        fontFamily: props.theme?.fontFamily,
                      }}
                      onClick={() => setIndex(index - 1)}
                    >
                      Back
                    </div>
                  )}
                </Fragment>
              ))
              .concat(
                <TicketBlock
                  key={"ticketBlock"}
                  userResponse={userResponse}
                  data={props.ticketData}
                  userScore={calculateScore(userResponse)}
                  fullname={userResponse.fullname}
                  ticketId={ticketId}
                  loadingStatus={loadingStatus}
                  fontColor={props.theme?.fontColor?.value}
                  themeColor={props.theme?.themeColor?.value}
                  fontFamily={props.theme?.fontFamily}
                />
              )}
          </Transition>
        </div>
      )}
    </div>
  );
}

function QuestionBlock(props: {
  themeData?: ThemeModel;
  data?: QuestionModel;
  onChange?: (e: CampaignAnswersModel) => void;
}) {
  const [userQuestionAnswer, setUserQuestionAnswer] =
    useState<CampaignAnswersModel>();
  return (
    <div className="campaign-question-block-container">
      <h2
        style={{
          color: props.themeData?.fontColor?.value,
          fontFamily: props.themeData?.fontFamily,
        }}
      >
        {props.data?.questionTitle}
      </h2>
      {(() => {
        switch (props.data?.questionType) {
          case QuestionTypes.MULTIPLE_CHOICE:
            return (
              <CampaignMultipleChoice
                optionsData={props.data.options}
                border={`2px solid ${
                  props.themeData?.fontColor?.value ??
                  "rgba(255, 255, 255, 0.5)"
                }`}
                color={
                  props.themeData?.fontColor?.value ?? "rgba(255, 255, 255, 1)"
                }
                fontFamily={props.themeData?.fontFamily}
                onChange={(e) => {
                  setUserQuestionAnswer({
                    id: props.data?.id,
                    questionType: QuestionTypes.MULTIPLE_CHOICE,
                    multipleChoiceAnswer: e,
                  } as CampaignAnswersModel);
                  props.onChange?.({
                    id: props.data?.id,
                    questionType: QuestionTypes.MULTIPLE_CHOICE,
                    multipleChoiceAnswer: e,
                  } as CampaignAnswersModel);
                }}
              />
            );
          case QuestionTypes.MULTIPLE_CHOOSE:
            return (
              <CampaignMultipleChoose
                optionsData={props.data.options}
                border={`2px solid ${
                  props.themeData?.fontColor?.value ??
                  "rgba(255, 255, 255, 0.5)"
                }`}
                color={
                  props.themeData?.fontColor?.value ?? "rgba(255, 255, 255, 1)"
                }
                fontFamily={props.themeData?.fontFamily}
                onChange={(e) => {
                  setUserQuestionAnswer({
                    id: props.data?.id,
                    questionType: QuestionTypes.MULTIPLE_CHOOSE,
                    multipleChooseAnswer: e,
                  } as CampaignAnswersModel);
                  props.onChange?.({
                    id: props.data?.id,
                    questionType: QuestionTypes.MULTIPLE_CHOOSE,
                    multipleChooseAnswer: e,
                  } as CampaignAnswersModel);
                }}
              />
            );
          case QuestionTypes.SHORT_ANSWER:
            return (
              <TextField
                fontSize="16px"
                fontFamily={props.themeData?.fontFamily}
                maxWidth={350}
                border={`2px solid ${
                  props.themeData?.fontColor?.value ??
                  "rgba(255, 255, 255, 0.5)"
                }`}
                color={
                  props.themeData?.fontColor?.value ?? "rgba(255, 255, 255, 1)"
                }
                isFullWidth
                initialValue={userQuestionAnswer?.shortAnswerAnswer}
                onChange={(e) => {
                  setUserQuestionAnswer({
                    id: props.data?.id,
                    questionType: QuestionTypes.SHORT_ANSWER,
                    shortAnswerAnswer: e,
                  } as CampaignAnswersModel);
                  props.onChange?.({
                    id: props.data?.id,
                    questionType: QuestionTypes.SHORT_ANSWER,
                    shortAnswerAnswer: e,
                  } as CampaignAnswersModel);
                }}
              />
            );
        }
      })()}
      <div style={{ height: "5vh" }} />
    </div>
  );
}

function StoryBlock(props: { data?: StoryModel; themeData?: ThemeModel }) {
  return (
    <div className="campaign-story-block-container">
      <h2
        style={{
          color: props.themeData?.fontColor?.value,
          fontFamily: props.themeData?.fontFamily,
        }}
      >
        {props.data?.storyTitle}
      </h2>
      {props.data?.storyImage && (
        <img
          src={props.data?.storyImage}
          width="100%"
          height="auto"
          style={{ maxWidth: "500px" }}
        />
      )}
      {props.data?.storyDescription && (
        <p
          style={{
            color: props.themeData?.fontColor?.value,
            fontFamily: props.themeData?.fontFamily,
          }}
        >
          {props.data?.storyDescription}
        </p>
      )}
      <div style={{ height: "5vh" }} />
    </div>
  );
}

function TicketBlock(props: {
  userResponse?: CampaignResponseModel;
  data?: TicketDetailModel;
  userScore?: number;
  fullname?: string;
  ticketId?: string;
  loadingStatus?: LoadingStatus;
  fontColor?: string;
  themeColor?: string;
  fontFamily?: string;
}) {
  const [id] = useState(uniqueId());
  const [withBGId] = useState(uniqueId());
  const ticketData = getTicketData();
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [ticketName, setTicketName] = useState<string>();

  const { loadingStatus, callFetchAsync } = useLoadHandler(
    async (file: File) => {
      let result = await FileApi.uploadFile(file);
      setTicketName(result);
      setIsShowPopup(true);
    }
  );

  function getTicketData() {
    let ticketIndex = 0;
    props.data?.userResult?.data?.rangeValues?.forEach((e) => {
      if (
        (props.userScore ?? 0) > e &&
        ticketIndex < (props.data?.userResult?.data?.rangeValues?.length ?? 0)
      ) {
        ticketIndex++;
      }
    });
    return props.data?.userResult?.data?.ticketRangeDetail?.[ticketIndex];
  }

  async function getImageFile(id: string) {
    let file: Blob = new Blob();
    await domtoimage.toBlob(document.getElementById(id) as Node);
    await domtoimage.toBlob(document.getElementById(id) as Node);
    await domtoimage.toBlob(document.getElementById(id) as Node);
    await domtoimage
      .toBlob(document.getElementById(id) as Node)
      .then(function (dataUrl) {
        file = dataUrl;
      })
      .catch(function (error) {
        console.error("oops, something went wrong!", error);
      });
    return file;
  }

  async function saveImage(id: string) {
    let file = await getImageFile(id);
    var link = document.createElement("a");
    document.body.appendChild(link);
    link.setAttribute("href", window.URL.createObjectURL(file));
    link.setAttribute("download", props.data?.eventName?.data ?? "unknwon");
    link.click();
  }

  return (
    <div style={{ width: "100%", maxWidth: "700px" }}>
      {props.loadingStatus == LoadingStatus.LOADING ? (
        <ReactLoading
          type={"spin"}
          color={Color().primaryColor}
          height={50}
          width={50}
        />
      ) : (
        <>
          <div className="user-ticket-container">
            <div>
              <Ticket
                isRealTicket
                ticketLayout={ticketLayouts[0]}
                backgroundImage={ticketData?.backgroundImage}
                logoImage={ticketData?.logoImage}
                description={ticketData?.description}
                date={props.data?.date?.isShow}
                eventName={props.data?.eventName?.data}
                fullName={props.fullname}
                ticketId={props.ticketId}
              />
            </div>
            <div className="ticket-button-container">
              <Button
                type={ButtonTypes.PRIMARY}
                text={"Save"}
                border={`2px solid ${props.themeColor ?? "#ffffff"}`}
                bgColor={props.themeColor ?? "#ffffff"}
                fontFamily={props.fontFamily}
                onClick={() => saveImage(id)}
              />
              <Button
                type={ButtonTypes.OUTLINED}
                loadingStatus={loadingStatus}
                text={"Share"}
                onClick={async () =>
                  callFetchAsync(await getImageFile(withBGId))
                }
                border={`2px solid ${props.fontColor ?? "#ffffff"}`}
                fontColor={props.fontColor ?? "#ffffff"}
                fontFamily={props.fontFamily}
              />
            </div>
          </div>
        </>
      )}
      {isShowPopup && (
        <ShareLinkPopup
          onClickClose={() => setIsShowPopup(false)}
          shareLink={(() => {
            var url = new URL(window.location.href);
            if (ticketName?.split("/")[ticketName?.split("/").length - 1])
              url.searchParams.set(
                "ticket",
                ticketName?.split("/")[ticketName?.split("/").length - 1]
              );
            return url.href;
          })()}
        />
      )}
      <div
        style={{
          position: "absolute",
          width: "0",
          height: "0",
          overflow: "hidden",
        }}
      >
        <StaticTicket
          id={id}
          width="670px"
          isRealTicket
          ticketLayout={ticketLayouts[props.data?.layoutNumber ?? 0]}
          backgroundImage={ticketData?.backgroundImage}
          logoImage={ticketData?.logoImage}
          description={ticketData?.description}
          date={props.data?.date?.isShow}
          eventName={props.data?.eventName?.data}
          fullName={props.fullname}
          ticketId={props.ticketId}
        />
      </div>
      <div
        style={{
          position: "absolute",
          width: "0",
          height: "0",
          overflow: "hidden",
        }}
      >
        <StaticTicket
          width="670px"
          id={withBGId}
          isRealTicket
          ticketLayout={ticketLayouts[props.data?.layoutNumber ?? 0]}
          backgroundImage={ticketData?.backgroundImage}
          logoImage={ticketData?.logoImage}
          description={ticketData?.description}
          date={props.data?.date?.isShow}
          eventName={props.data?.eventName?.data}
          fullName={props.fullname}
          ticketId={props.ticketId}
          withBackground
        />
      </div>
    </div>
  );
}
